export default __webpack_public_path__ + "static/media/review2.2c9cccd2.jpg";